/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, IconButton, makeStyles, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
import { SearchCriteria } from '../SearchCriteria';
import CloseIcon from '@material-ui/icons/Close';
import { formatNumber } from '../../helpers/ChartHelper';
// import { DrillDownType } from '../DrillDownType';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { getElementAtEvent, Pie } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, ChartEvent, ActiveElement, Chart } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { useScreenshot, createFileName } from 'use-react-screenshot';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import MTooltip from '@material-ui/core/Tooltip';
import { ChartInfo } from '../../components/ChartInfo';
import { VideoModal } from '../../components/VideoModal';
import { DrillDownType } from '../DrillDownType';
import { AIIcon } from '../../components/icons/AIIcon';
import html2canvas from 'html2canvas';
import { AIChartDialog } from '../../components/Dialogs/AIChartDialog';

import { RV_CHART_CLASS, RV_CHART_COLORS, rvChartAnimation, rvTooltipStyle, rvLegendLabels, isChartDataEmpty } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { ChartNotes } from '../ChartNotes';
import { ChartEmptyState } from '../ChartEmptyState';
import { AnimatedNumber } from '../AnimatedNumber';
import DonutLargeOutlinedIcon from '@material-ui/icons/DonutLargeOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px 0px 15px',
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '350px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        scrollUp: {
            position: 'absolute',
            top: '30px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        scrollDown: {
            position: 'absolute',
            bottom: '90px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        }
    }),
);

interface TotalDebtOwingPieChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    infoUrl: string;
}

interface ChartState extends TotalDebtOwing {
    symbol: string;
    isVideoModalOpen: boolean;
}

export const TotalDebtOwingPieChart: React.FC<TotalDebtOwingPieChartProps> = (props) => {
    const classes = useStyles();

    const chartName = 'Total Debt Owing';

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const entireChartRef = React.useRef<any>();

    const [base64Data, setBase64Data] = useState<string | ArrayBuffer | null>(null);
    
    const [isAIDialogOpen, setIsAIDialogOpen] = useState<boolean>(false);

    const [isBlobGenerating, setIsBlobGenerating] = useState<boolean>(false);

    const takeScreenShot = useScreenshot({
        type: 'image/jpeg',
        quality: 1.0
    })[1];

    const currencySymbolQuery = useQuery<CurrencySymbolData>(CURRENCY_SYMBOL_QUERY);

    const totalDebtOwingQuery = useQuery<TotalDebtOwingData, TotalDebtOwingDataParams>(TotalDebtOwingQuery, {
        variables: {
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
            showAllRecords: props.showAllRecords
        }
    });
    
    const [state, setState] = useState<ChartState>({
        total: 0,
        symbol: '$',
        totalDebtOwingGrouped: [],
        isVideoModalOpen: false
    });

    useEffect(() => {
        if (totalDebtOwingQuery.data && totalDebtOwingQuery.data.statistics && !totalDebtOwingQuery.loading && !totalDebtOwingQuery.error) {
            setState((prevState) => {
              
                const { total, totalDebtOwingGrouped } = totalDebtOwingQuery.data!.statistics.matter.totalDebtOwing;

                return {
                    ...prevState,
                    total,
                    totalDebtOwingGrouped
                };
            });
        }

        // tslint:disable-next-line: align
    }, [totalDebtOwingQuery.loading, totalDebtOwingQuery.error, totalDebtOwingQuery.data]);

    useEffect(() => {
        if (currencySymbolQuery.data && currencySymbolQuery.data.options && !currencySymbolQuery.loading && !currencySymbolQuery.error) {
            setState((prevState) => {
                return {
                    ...prevState,
                    symbol: currencySymbolQuery.data!.options.currencySymbol.symbol,
                };
            });
        }

        // tslint:disable-next-line: align
    }, [currencySymbolQuery.loading, currencySymbolQuery.error, currencySymbolQuery.data]);

    const groupLabel = [
        { name: 'Current', label: 'Current' },
        { name: 'ThirtyDays', label: '30 days' },
        { name: 'SixtyDays', label: '60 days' },
        { name: 'NinetyDays', label: '90 days' }
    ] as const;

    const groupBy = state.totalDebtOwingGrouped.map((group) => group.groupedBy);
    const debtOwingValue = state.totalDebtOwingGrouped.map((group) => group.value);

    const mappedLabels = groupBy.map((groupName) => {
        const labelObject = groupLabel.find((group) => group.name === groupName);
        return labelObject ? labelObject.label : undefined;
    });

    const onCloseChart = () => {
        if (props.onCloseChart) {
            return props.onCloseChart(`isTotalDebtOwingPieOpen`);
        }
    };

    const onMaximize = () => {
        if (props.onMaximize) {
            props.onMaximize();
        }
    };

    // tslint:disable-next-line: no-any
    const onDownload = (name: string, extension: string = 'jpg') => (image: any) => {
        const a = document.createElement('a');
        a.href = image;
        a.download = createFileName(extension, name);
        a.click();
    };

    const onDownloadScreenshot = () => {
        setTimeout(() => {
            takeScreenShot(entireChartRef.current).then(onDownload('Total Debt Owing - Pie Chart'));
            // tslint:disable-next-line: align
        }, 500);
    };

    const onAIGeneratedSuggestion = async (event: any) => {

        setIsBlobGenerating(true);

        event.preventDefault();
        event.stopPropagation();
       
        if (entireChartRef && entireChartRef.current) {
            const canvas = await html2canvas(entireChartRef.current);
            canvas.toBlob((blob) => {
                if (blob) {
                    const reader = new FileReader();
                    reader.readAsDataURL(blob);
                    reader.onloadend = async () => {
                        const tempBase64data = reader.result;
                        // console.log(tempBase64data); // This is your image blob string
                        setBase64Data(tempBase64data);
                        setIsAIDialogOpen(true);
                    };
                }
            });
        }

        setIsBlobGenerating(false);
    };

    const chartControllerComponent = () => {
        return (
            <>
<IconButtonWrapper aria-label="close">
                    <ChartInfo 
                        description={props.description}
                        fontSize={props.showAllRecords ? 'large' : 'medium'}
                        className={`${classes.helpIcon} rv-chart-help`}
                    />
                    {props.isAIFeatureEnabled && (
                        <MTooltip title="AI Assistant">
                            <IconButton 
                                disabled={isBlobGenerating}
                                size={props.showAllRecords ? 'medium' : 'small'}
                                onClick={onAIGeneratedSuggestion}
                            >
                                <AIIcon 
                                    color="primary"
                                    fontSize={props.showAllRecords ? 'large' : 'medium'}
                                />
                            </IconButton>
                        </MTooltip>
                    )}
                    {props.showAllRecords && (
                        <IconButton size="medium" onClick={onDownloadScreenshot}>
                            <GetAppOutlinedIcon color="primary" fontSize="large" />
                        </IconButton>
                    )}
                    {!props.showAllRecords && props.onMaximize && (
                        <MTooltip title="Expand chart">
                            <IconButton aria-label="maximize" onClick={onMaximize} size="small">
                                <AspectRatioIcon />
                            </IconButton>
                        </MTooltip>
                    )}
                    <IconButton aria-label="close" onClick={onCloseChart} size={props.showAllRecords ? 'medium' : 'small'}>
                        <CloseIcon className={classes.closeIcon} fontSize={props.showAllRecords ? 'large' : 'medium'} />
                    </IconButton>
                </IconButtonWrapper>
            </>
        );
    };

    const handleTotalClick = () => {
        if (props.getSelectedItem) {
            const searchCriterias = new Array<SearchCriteria>();

            searchCriterias.push(
                { property: 'DebtOwing', operator: 'not', comparison: '0' },
                { property: 'DebtOwing', operator: 'isnot', comparison: 'null' }
            );

            props.getSelectedItem(searchCriterias, true, 'Total Debt Owing', DrillDownType.matterSummaryDrilldown, 'Debtors');
        }
    };

    const onToggleVideo = () => {
        setState((prevState) => {
            return {
                ...prevState,
                isVideoModalOpen: !prevState.isVideoModalOpen
            };
        });
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };
    
    if (totalDebtOwingQuery.loading || currencySymbolQuery.loading) {
        return (
            <ChartSkeleton variant="pie" />
        );
    }

    return (
        <>
            {isAIDialogOpen && (
                <AIChartDialog 
                    fullWidth={true}
                    maxWidth="md"
                    open={isAIDialogOpen}
                    onClose={() => setIsAIDialogOpen(false)}
                    data={base64Data}
                    query={props.aiPrompt || 'Give me recommendations on this and highlight any exceptions or concerns'}
                    accessSubType={chartName}
                    layoutId={props.layoutId}
                />
            )}
            {state.isVideoModalOpen && props.infoUrl && <VideoModal open={state.isVideoModalOpen} onClose={onToggleVideo} url={props.infoUrl} />}
            <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(debtOwingValue) ? ' rv-chart--empty' : ''}`} ref={entireChartRef}>
                {chartControllerComponent()}
                <div className={classes.titleContainer}>
                    <ChartHeading icon={<DonutLargeOutlinedIcon />} title={chartName} />
                    <div className={`${classes.total} h2`} onClick={handleTotalClick}>
                        <AnimatedNumber value={state.total} format={(amount) => `${state.symbol}${formatNumber(amount)}`} />
                    </div>
                </div>
                <div className={classes.barContainer}>
                    <Pie
                        ref={chartRef}
                        // tslint:disable-next-line: no-any
                        onClick={(event: React.MouseEvent<any>) => {
                            const _data = getElementAtEvent(chartRef.current, event);
                            if (_data.length > 0 && props.getSelectedItem) {
                                const _index = getElementAtEvent(chartRef.current, event)[0].index;

                                const item = ['Current', '30 days', '60 days', '90 days'][_index];

                                const searchCriterias = new Array<SearchCriteria>();

                                let property = '';

                                if (item === 'Current') {
                                    property = 'Aged0DebtorsBalanceIncTax';
                                } else if (item === '30 days') {
                                    property = 'Aged1DebtorsBalanceIncTax';
                                } else if (item === '60 days') {
                                    property = 'Aged2DebtorsBalanceIncTax';
                                } else if (item === '90 days') {
                                    property = 'Aged3DebtorsBalanceIncTax';
                                }

                                searchCriterias.push(
                                    { property: property, operator: 'not', comparison: '0' },
                                    { property: property, operator: 'isnot', comparison: 'null' },
                                    { property: 'DebtOwing', operator: 'not', comparison: '0' },
                                    { property: 'DebtOwing', operator: 'isnot', comparison: 'null' },
                                );

                                props.getSelectedItem(
                                    searchCriterias, 
                                    true, 
                                    `Total Debt Owing - ${item}`, 
                                    DrillDownType.matterSummaryDrilldown, 
                                    'Debtors'
                                );
                            }
                        }}
                        data={{
                            labels: mappedLabels,
                            datasets: [
                                {
                                    data: debtOwingValue,
                                    backgroundColor: [RV_CHART_COLORS.primarySoft, RV_CHART_COLORS.primary, RV_CHART_COLORS.amber, RV_CHART_COLORS.red],
                                    hoverBackgroundColor: [RV_CHART_COLORS.primarySoft, RV_CHART_COLORS.primary, RV_CHART_COLORS.amber, RV_CHART_COLORS.red],
                                    borderColor: '#ffffff',
                                    borderWidth: 2,
                                    hoverOffset: 8,
                                },
                            ],
                        }}
                        options={{
                            onHover: onHover,
                            animation: { ...rvChartAnimation(), animateRotate: true, animateScale: true },
                            layout: { padding: 8 },
                            responsive: true,
                            maintainAspectRatio: false,
                            plugins: {
                                legend: {
                                    position: 'bottom' as const,
                                    display: true,
                                    labels: rvLegendLabels,
                                },
                                title: {
                                    display: false,
                                },
                                tooltip: {
                                    ...rvTooltipStyle,
                                    callbacks: {
                                        // tslint:disable-next-line: no-any
                                        label: function (context: any) {
                                            const {
                                                // dataIndex,
                                                label,
                                                formattedValue,
                                            } = context;
                                            // tslint:disable-next-line: radix
                                            return `${label}: ${state.symbol}${formattedValue}`;
                                        },
                                        // tslint:disable-next-line: no-any
                                        afterLabel: function (context: any) {
                                            const { dataIndex } = context;

                                            const group = state.totalDebtOwingGrouped[dataIndex];

                                            return [`Percentage: ${formatNumber(group.percentageCount, 1)}%`];
                                        },
                                    },
                                },
                            },
                        }}
                    />
                    {isChartDataEmpty(debtOwingValue) && (
                        <ChartEmptyState title="No debt owing" hint={"Nothing is owing right now."} />
                    )}
                </div>
                <ChartNotes notes={['Information collated by Matter Responsibility']} actionHint="Drill down to matters" />
                {/* <span className={classes.span}>Information collated based on Timekeeper</span>
                <span className={classes.span}>Drill down to timekeeper details</span>     
                <span className={classes.span}>The top 10 timekeepers are shown</span>                           */}
            </div>
        </>
    );
};

export interface CurrencySymbolData {
    options: Options;
}

export interface Options {
    currencySymbol: CurrencySymbol;
}

export interface CurrencySymbol {
    symbol: string;
}

export const CURRENCY_SYMBOL_QUERY = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;

export type TotalDebtOwingDataParams = {
    entityType?: number;
    entityGuid?: string, 
    responsibility?: number, 
    showAllRecords?: boolean
};

export type TotalDebtOwingData = {
    statistics: Statistics;
};

export type Statistics = {
    matter: Matter;
};

export type Matter = {
    totalDebtOwing: TotalDebtOwing;
};

export type TotalDebtOwing = {
    total:                 number;
    totalDebtOwingGrouped: TotalDebtOwingGrouped[];
};

export type TotalDebtOwingGrouped = {
    value:           number;
    groupedBy:       string;
    percentageCount: number;
};

const TotalDebtOwingQuery = gql`
    query TotalDebtOwing($entityType: Int, $entityGuid: String, $responsibility: Int, $showAllRecords: Boolean) {
        statistics {
            matter {
                totalDebtOwing(entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility, showAllRecords: $showAllRecords) {
                    total
                    totalDebtOwingGrouped {
                        value
                        groupedBy
                        percentageCount
                    }
                }
            }
        }
    }
`;
